import {RestrictionType, restrictionTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<RestrictionType>;

export const RestrictionTypeSelect = (props: Props) => {
    const {options = restrictionTypes, ...rest} = props;
    return <BaseDbCodeSelect options={options} {...rest} />;
};
